import { createFileRoute } from '@tanstack/react-router';
import { ReviewPage } from '@features/review/ReviewPage';

export const Route = createFileRoute('/review/$token')({
  component: ReviewRoute,
});

function ReviewRoute() {
  const { token } = Route.useParams();
  return <ReviewPage token={token} />;
}
